import type { Dictionary } from '../i18n.js';

/** The world build's progress and time estimates, shared by the wizard and the lobby. */
export const build: Dictionary = {
  // buildClock.ts
  '{s}s': '{s} s',
  '{m}m {s}s': '{m} min {s} s',
  // Only ever a multiple of five, so never the "2–4" form: 5, 10 … 55 sekund.
  '{s} seconds': '{s} sekund',
  '{m} min': '{m} min',
  'Taking longer than expected — the map server is busy. Still going.':
    'Trwa to dłużej, niż szacowaliśmy — serwer map jest zajęty. Budowanie trwa dalej.',
  'Almost there': 'Już prawie',
  'About {time} left': 'Zostało około {time}',

  // raceWizard.ts — the check step while it builds, and the estimate under the area meter
  'Building the region to check it…': 'Buduję obszar, żeby go sprawdzić…',
  'First time here, so the streets are downloading. Next time is quick.':
    'Pierwszy raz tutaj, więc ulice się pobierają. Następnym razem pójdzie szybko.',
  'Working out how long this takes to build…': 'Sprawdzam, ile potrwa budowanie…',
  'The server already has these streets, so this builds in seconds.':
    'Serwer ma już te ulice, więc obszar zbuduje się w kilka sekund.',
  'The server is offline and does not have these streets, so this area cannot be built. Use a built-in region instead.':
    'Serwer działa offline i nie ma tych ulic, więc tego obszaru nie da się zbudować. Wybierz gotowy obszar.',
  'About {time} to build — the server downloads these streets from OpenStreetMap first.':
    'Budowanie potrwa około {time} — serwer najpierw pobierze te ulice z OpenStreetMap.',
  'Map tiles still to download: {missing} of {total}. Afterwards they are kept, so the next race here is quick.':
    'Kafelki mapy do pobrania: {missing} z {total}. Potem zostają na serwerze, więc następny wyścig tutaj ruszy szybko.',
};
